export default "__VITE_ASSET__YDwI803r__"